export const SITE_URL = 'https://heavengirlfriend.com';

export const SOCIAL_PROFILES = {
  instagram: 'https://www.instagram.com/heaven_girlfriend/',
  youtube: 'https://www.youtube.com/channel/UCZShk9xrFeYoMKvwY-lHG4g',
  facebook: 'https://facebook.com/heaven.girlfriend',
  x: 'https://x.com/hvngirlfriend',
  tiktok: 'https://www.tiktok.com/@heavengirlfriend',
} as const;

export const ORGANIZATION_SAME_AS = [
  SOCIAL_PROFILES.instagram,
  SOCIAL_PROFILES.youtube,
  SOCIAL_PROFILES.facebook,
  SOCIAL_PROFILES.x,
  SOCIAL_PROFILES.tiktok,
] as const;
